import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

interface NavTranslations {
  nav_quienes: string;
  nav_servicios: string;
  nav_trabajos: string;
  nav_contacto: string;
  cta_email: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  lang: 'ESP' | 'ENG' = 'ESP';
  menuOpen = false;
  t: NavTranslations = {} as NavTranslations;

  private translations: Record<'ESP' | 'ENG', NavTranslations> = {
    ESP: {
      nav_quienes:   'Quiénes somos',
      nav_servicios: 'Servicios',
      nav_trabajos:  'Trabajos',
      nav_contacto:  'Contacto',
      cta_email:     'Escribinos',
    },
    ENG: {
      nav_quienes:   'About us',
      nav_servicios: 'Services',
      nav_trabajos:  'Works',
      nav_contacto:  'Contact',
      cta_email:     'Get in touch',
    },
  };

  constructor(private router: Router) {}

  ngOnInit(): void {
    let saved: 'ESP' | 'ENG' | null = null;
    try { saved = sessionStorage.getItem('idioma') as 'ESP' | 'ENG' | null; } catch {}
    this.lang = saved ?? 'ESP';
    this.t = this.translations[this.lang];
  }

  setLang(lang: 'ESP' | 'ENG'): void {
    this.lang = lang;
    try { sessionStorage.setItem('idioma', lang); } catch {}
    this.t = this.translations[this.lang];
  }

  // Navega a una sección. Si la sección existe en la página actual hace scroll,
  // si no (estamos en otra ruta como /servicio/:id) navega a home y la deja marcada
  // para que la portada haga scroll una vez montada.
  goTo(id: string): void {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      localStorage.setItem('pos', id);
      this.router.navigate(['/']);
    }
    this.menuOpen = false;
  }
}
